__webpack_require__.p = "https://staging.animaltrainingjournal.com/";